module.exports = __webpack_public_path__ + "static/media/financial.f6bb5b87.svg";